import axios from "axios";
import store from "@/store";

const BASE_URL = process.env.VUE_APP_API_URL || "http://localhost:3000";

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

const clearAuth = () => {
  store.commit("CLEAR_AUTH");
  window.location.href = "/login";
};

api.interceptors.request.use((config) => {
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }

  // Empresa da store (memória desta aba), não do localStorage: o
  // localStorage é compartilhado entre abas, então trocar de empresa numa
  // aba fazia a outra — ainda mostrando a empresa anterior — gravar na nova.
  const company = store.state.currentCompany;
  if (company?.id) {
    config.headers["X-Company-Id"] = company.id;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem("refreshToken");

      if (!refreshToken) {
        clearAuth();
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axios.post(
          `${BASE_URL}/refresh`,
          {},
          { headers: { Authorization: `Bearer ${refreshToken}` } }
        );

        const { auth_token } = response.data;
        store.commit("SET_TOKEN", auth_token);
        processQueue(null, auth_token);
        originalRequest.headers.Authorization = `Bearer ${auth_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Renovação falhou: as requisições que esperavam na fila falham
        // também (antes eram refeitas com "Bearer null").
        processQueue(refreshError || error);
        clearAuth();
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
